import DashboardNavItem from "./DashboardNavItem";

export default DashboardNavItem;